import AbstractHTML5Player from '../all/AbstractHTML5Player';
import * as playerConstants from '../../utils/playerConstants';
import Utils from '../../utils/Utils';
import { AAF_CONTENT_IS_VOD } from '../../AAFPlayer/constants';
class ZeasnPlayer extends AbstractHTML5Player {
  constructor() {
    super();
    this.canPlay = false;
    this.retryLimitAudioTrack = 20;
    this.itv = null;
  }

  getStreamType() {
    switch (this.options.streamType) {
      case playerConstants.HLS:
      case playerConstants.HLS_KR:
        return 'application/vnd.apple.mpegurl';
        break;
      case playerConstants.AUDIO:
      case playerConstants.RADIO:
        return 'audio/mp4';
        break;
      case playerConstants.SS:
      case playerConstants.SS_MA:
        return 'application/vnd.ms-playready.initiator+xml';
        break;
      default:
        return null;
        break;
    }
  }

  setVideoSource(url, type) {
    console.log('******* <<<<<<<<<<< INIT zeasn AbstractHTML5Player setVideoSource: ' + url);
    let source = document.createElement('source');
    source.src = url;

    console.log('ESV: setting stream type', this.options.streamType, this.getStreamType());
    type = this.getStreamType();
    if (type) source.type = type;

    source.id = 'Html5PlayerSource' + (this.options.isPip ? '_pip' : '_full');
    this._playerHTMLTag.appendChild(source);

    console.log('******* <<<<<<<<<<< END zeasn AbstractHTML5Player setVideoSource');
  }

  getAudioIndexOfCode(codeTrack) {
    if (Utils.isSonyBraviaOperaBrowser() || this.isLanguageCodeByIso2()) {
      return this.audioTracks.findIndex(track => {
        return this.getLanguageCodeByISO3(codeTrack) === track.language;
      });
    } else {
      return this.audioTracks.findIndex(track => track.language === codeTrack);
    }
  }

  _onCanPlay(e) {
    if (this.itv) clearInterval(this.itv);
    if (this.options.events.onCanPlay) {
      this.options.events.onCanPlay(e);
    }
    if (this.canPlay) return;
    this.canPlay = true;
  }

  loadMedia() {
    if (this.itv) clearInterval(this.itv);

    if (!this._isPrepared) {
      return false;
    }
    if (this.streamIsImage()) {
      return;
    }

    super.loadMedia();

    let isVOD =
      this.options &&
      this.options.streamContentType &&
      this.options.streamContentType === AAF_CONTENT_IS_VOD;

    if (this.options && this.options.streamType && this.options.src) {
      switch (this.options.streamType) {
        case playerConstants.SS:
        case playerConstants.SS_MA:
          if (isVOD) {
            this.itv = setInterval(() => {
              // Force HTML5 video tag play :/
              let ele = document.getElementById('Html5Player_full');
              if (ele) {
                ele.play();
              }
              console.log('ZEASN FORCING BUFFERING && PLAY');
            }, 500);
          }
          break;
        default:
          break;
      }
    }
  }

  play() {
    if (this.streamIsImage()) {
      return;
    }
    this.show();
    this._playerHTMLTag.play();
  }

  destroy() {
    if (this.itv) clearInterval(this.itv);
    if (!this._isPrepared) {
      return;
    }
    this.canPlay = false;
    super.destroy();
  }

  replaceMediaSource(newSource) {
    if (this.itv) clearInterval(this.itv);
    this.canPlay = false;
    super.replaceMediaSource(newSource);
  }

  _onError(e) {
    if (this.itv) clearInterval(this.itv);
    super._onError(e);
  }
}

export default ZeasnPlayer;



// WEBPACK FOOTER //
// ./src/devices/zeasn/Player.js